import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RoleService } from 'app/services/models/role.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-role-managment-update',
  templateUrl: './role-managment-update.component.html',
  styleUrls: ['./role-managment-update.component.scss']
})
export class RoleManagmentUpdateComponent implements OnInit {
  @Input() data: any;
  public roleName:string = '';

  constructor(
    public ngbModal:NgbActiveModal,
    private roleService:RoleService,
    private toastServices:ToastrService
  ) { }
  
 
  ngOnInit(): void {
    console.log("gelen veri : ",this.data);
    this.roleName = this.data.name;
  }
  closeModal() {
    this.ngbModal.close('Modal Kapatıldı.');
  }
  
  async updateRole(name){
    const data = await this.roleService.updateRole(this.data.id,name);
    console.log("Güncelleme : " +data);
    if(data == true)
      this.toastServices.success("Rol adı başarılı bir şekilde güncellendi.");
    else
      this.toastServices.error("Rol adı güncellenemedi.");
    
      this.closeModal();
  }
}
